import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import ElementUI from 'element-ui';
import ECharts from 'vue-echarts'; // 在 webpack 环境下指向 components/ECharts.vue

import vuetify from './plugins/vuetify';
import 'element-ui/lib/theme-chalk/index.css';

import 'material-design-icons/iconfont/material-icons.css';
// 手动引入 ECharts 各模块来减小打包体积
import 'echarts/lib/chart/bar';
import './utils/cookie';
import 'echarts/lib/chart/line';
import { i18n, langSetup } from './lang';

Vue.prototype.$moment = moment;
Vue.use(ElementUI);
// 注册组件后即可使用
Vue.component('v-chart', ECharts);
Vue.langSetup = Vue.prototype.$langSetup = langSetup;
import './register-components.js';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
